import Slider from "@material-ui/core/Slider";
import Typography from "@material-ui/core/Typography";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { AccountCircle, MonetizationOn } from "@material-ui/icons";
import { Tooltip } from "antd";
import React from "react";

const useStyles = makeStyles({
	root: {
		width: "100%",
		marginBottom: 10,
	},
	typography: {
		marginBottom: 20,
	},
});

const InfoSlider = withStyles({
	root: {
		color: "#3a8589",
		height: 3,
		padding: "13px 0",
		"& .MuiIcon-fontSizeLarge": {
			fontSize: 30,
		},
		"& .MuiIcon-colorPrimary": {
			color: "#000",
		},
	},
	thumb: {
		height: 30,
		width: 30,
		backgroundColor: "#fff",
		marginTop: -14,
		marginLeft: -7,
		"& .bar": {
			height: 9,
			width: 1,
			backgroundColor: "#ff960c",
			marginLeft: 1,
			marginRight: 1,
		},
	},
	active: {},
	valueLabel: {
		left: "calc(-50% + 4px)",
		fontSize: "1.8rem",
	},
	track: {
		height: 3,
		backgroundColor: "#ff960c",
	},
	rail: {
		backgroundColor: "#ff960c",
		opacity: 1,
		height: 3,
	},
	mark: {
		backgroundColor: "#ff960c",
		height: 18,
		width: 18,
		borderRadius: 18,
		marginTop: -7,
	},
	markActive: {
		opacity: 1,
		backgroundColor: "#ff960c",
	},
	markLabel: {
		fontSize: "1.8rem",
		top: 30,
		color: "#a7a7a7",
	},
	markLabelActive: {
		color: "#a7a7a7",
	},
})(Slider);

function ValueLabelComponent(props, data) {
	const { children, open } = props;
	return (
		<Tooltip open={open} enterTouchDelay={0} placement="top" title={data.title}>
			{children}
		</Tooltip>
	);
}

function ThumbComponent(props, data) {
	return (
		<span {...props}>
			{data.parent === "contact" ? (
				<AccountCircle style={{ color: "#000", fontSize: 33 }} />
			) : (
				<MonetizationOn style={{ color: "#000", fontSize: 33 }} />
			)}
		</span>
	);
}

export default function CustomSlider(props) {
	const classes = useStyles();

	return (
		<div className={`${classes.root} col-md-12`}>
			<Typography
				className={classes.typography}
				variant="h4"
				align="left"
				id="discrete-slider"
				gutterBottom={true}
			/>
			<InfoSlider
				defaultValue={props.defaultValue}
				aria-labelledby="discrete-slider"
				ThumbComponent={(e) => ThumbComponent(e, props)}
				ValueLabelComponent={(e) => ValueLabelComponent(e, props)}
				step={null}
				marks={props.marks}
				min={props.min}
				max={props.max}
				onChange={props.onChange}
				value={props.value}
			/>
		</div>
	);
}
